module.exports = __webpack_public_path__ + "img/accept.5277d76e.svg";